
export default {
    data() {
        return {
            // 存放了相关的属性名 数据  
            names: [],
            num: {
            }
        }
    },
    methods: {
    },
    created() {
        this.$getStoreId().then(shop_id => {
            let data = {
                offset: 0,
                length: 10,
                shop_id: shop_id
            }
            // ajax 请求 是可以传入一个对象 
            this.$post("navigation_bar/search", data).then(res => {
                // 可以拿到相关的数据 
                //  res.data.result.data 这里得到的数据只有一条 是通过shop_id 的形式去筛选得到的 
                //  将id 作为自己的调条件 进入按请求的数据进行筛选 
                this.names = res.data.result.data
                // // console.log('sasas',this.names.length)

                for(let i=0;i<this.names.length;i++){
                    // // console.log(typeof this.names[i].url )
                    // 正则表达式进行判断 为空或者多个空格的时候 就进行处理，除取多个空格 得到最终的长度 
                    if(this.names[i].url.replace(/(^\s*)|(\s*$)/g, "").length ==0){
                        this.names[i].url="javascript:void(0)"
                    }
                }

            })
        })




    }
}